// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"e088a7b2","lsc":"ac850042","others":"0c346406"}[chunkId] + ".chunk.js";
};